import { type RJSFSchema } from '@rjsf/utils'

export interface FinalizeSampleFormData {
  followUp: boolean
  followUpComment: string
}

export const getFinalizeSampleSchema = (
  shallFollowUp?: boolean,
  comment?: string
): RJSFSchema => ({
  type: 'object',
  properties: {
    followUp: {
      type: 'boolean',
      title: 'Oppfølging',
      ...(typeof shallFollowUp === 'boolean' && { default: shallFollowUp }),
      oneOf: [
        {
          const: true,
          title: 'Skal følges opp'
        },
        {
          const: false,
          title: 'Trenger ingen oppfølging'
        }
      ]
    }
  },
  required: ['followUp'],
  allOf: [
    {
      if: {
        properties: {
          followUp: {
            const: true
          }
        },
        required: ['followUp']
      },
      then: {
        properties: {
          followUpComment: {
            type: 'string',
            title: 'Beskriv hvordan prøven skal følges opp',
            maxLength: 1000,
            ...(typeof comment === 'string' && { default: comment })
          }
        },
        required: ['followUpComment']
      }
    },
    {
      if: {
        properties: {
          followUp: {
            const: false
          }
        },
        required: ['followUp']
      },
      then: {
        properties: {
          followUpComment: {
            type: 'string',
            title: 'Kommentar',
            maxLength: 1000,
            ...(typeof comment === 'string' && { default: comment })
          }
        }
      }
    }
  ]
})
